import React, {useCallback, useEffect, useState} from 'react';
import {Helmet} from "react-helmet-async";
import {useLocation} from "react-router-dom";
import {IMaskInput} from "react-imask/esm";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import {CheckCircle2} from "lucide-react";

const ContactsPage = () => {

    const contactInfo = [
        {
            icon: '📍',
            title: 'Локація',
            details: 'селище Ясіня, Рахівський р-н, Закарпатська обл., Україна',
            link: 'https://www.google.com/maps/place/%D0%AF%D1%81%D1%96%D0%BD%D1%8F,+%D0%97%D0%B0%D0%BA%D0%B0%D1%80%D0%BF%D0%B0%D1%82%D1%81%D1%8C%D0%BA%D0%B0+%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C,+90630/@48.2589986,24.3492606,13z/data=!3m1!4b1!4m6!3m5!1s0x47371bc0f34d709d:0xd0a21dbd04526da6!8m2!3d48.2595628!4d24.3450737!16s%2Fm%2F06wbjm2?hl=uk-UA&entry=ttu&g_ep=EgoyMDI2MDgyNi4wIKXMDSoASAFQAw%3D%3D'
        },
        {
            icon: '📞',
            title: 'Телефон / Viber / Telegram',
            details: '+380 (97) 902 00 18',
            link: 'tel:+380 (97) 902 00 18'
        },
        {
            icon: '📸',
            title: 'Instagram',
            details: '@hlushman_house',
            link: 'https://www.instagram.com/hlushman_house/'
        },
        {
            icon: '✉️',
            title: 'Email',
            details: 'hlushman.site@gmail.com',
            link: 'mailto: hlushman.site@gmail.com'
        }
    ];

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [formData, setFormData] = useState({ name: '', phone: '', date: '', message: '' });

    // reCaptcha
    const { executeRecaptcha } = useGoogleReCaptcha();

    // send offer

    const handleFormSubmit = useCallback( async (e) => {
        e.preventDefault();

        //
        if (!executeRecaptcha) {
            console.error('reCAPTCHA ще не завантажилася');
            return;
        }

        const token = await executeRecaptcha('contact_form');

        if (!token) {
            console.error('Не вдалося отримати токен reCAPTCHA');
            return;
        }

        const formData = new FormData(e.target);

        const name = formData.get('name');
        const phone = formData.get('phone');
        const note = formData.get('note');
        const message = `<b>Зворотній зв'язок</b>
                            👤 <b>Ім'я:</b> ${name}
                            📞 <b>Телефон:</b> ${phone}
                            🗒️ <b>Примітка:</b> ${note}`;

        formData.append('text', message);
        // formData.append('parse_mode', 'HTML');
        // formData.append('recaptchaToken', token);

        try {

            const response = await fetch('https://myoffice.cv/sending/telegram.php', {
                method: 'POST',
                body: formData
            });

            const result = await response.json();

            if (result.ok) {
                localStorage.setItem('form_submitted_3', 'true');
            } else {
                alert('Помилка: ' + result.message);
            }

            window.location.reload();
        } catch (error) {
            console.error('Помилка відправки:', error);
            console.error('Помилка відправки:', error);
        }

        setFormSubmitted(true);
        localStorage.setItem('form_submitted_3', 'true');

        setTimeout(() => {
            setIsModalOpen(false);
            setFormData({ name: '', phone: '', message: '' });
        }, 2500);
    }, [executeRecaptcha]);

    useEffect(() => {

        const status = localStorage.getItem('form_submitted_3');
        if (status === 'true') {
            setFormSubmitted(true);
        }
    }, []);


    return (
       <>
           <Helmet>
               <title>Контакти — Hlushman House</title>
               <meta name="title" content="Контакти" />
               <meta name="description" content="Контакти: телефони, адреса офісу, електронна пошта та інтерактивна карта проїзду" />
               <meta property="og:title" content="Контакти — Hlushman House" />
               <meta property="og:description" content="Зв'яжіться з нами: телефони, адреса офісу, електронна пошта та інтерактивна карта проїзду. Ми завжди на зв'язку!" />
               <meta property="og:image" content="https://hlushman.site/img/logo.jpg" />
               <meta property="og:url" content="https:///hlushman.site/contacts" />
           </Helmet>

           <div className="bg-stone-50 text-stone-800 min-h-screen font-sans">

               {/* Header Section */}
               <section className="bg-stone-900 text-white py-16 px-6 text-center">
                   <div className="max-w-4xl mx-auto">
                       <span className="text-emerald-400 font-semibold tracking-widest uppercase text-sm">Зв'язок з нами</span>
                       <h1 className="text-4xl md:text-5xl font-serif font-bold mt-2 mb-4">Контакти</h1>
                       <p className="text-stone-300 max-w-xl mx-auto font-light">
                           Маєте запитання або бажаєте забронювати відпочинок? Напишіть або зателефонуйте нам — ми завжди на зв'язку!
                       </p>
                   </div>
               </section>

               {/* Main Content: Info & Form */}
               <section className="py-16 px-6 max-w-6xl mx-auto">
                   <div className="grid lg:grid-cols-2 gap-12">

                       {/* Contact Details */}
                       <div className="space-y-8">
                           <h2 className="text-2xl font-serif font-bold text-stone-900 mb-6">Як з нами зв'язатися</h2>

                           <div className="grid sm:grid-cols-2 gap-6">
                               {contactInfo.map((item, idx) => (
                                   <a
                                       key={idx}
                                       href={item.link}
                                       // onClick={() => handleLinkClick('text', item.link)}
                                       target="_blank"
                                       rel="noopener noreferrer"
                                       className="p-6 bg-white rounded-2xl border border-stone-200 hover:shadow-md transition duration-300 flex flex-col justify-between"
                                   >
                                       <div>
                                           <div className="text-3xl mb-3">{item.icon}</div>
                                           <h3 className="font-semibold text-stone-900 mb-1">{item.title}</h3>
                                           <p className="text-stone-600 text-sm leading-relaxed">{item.details}</p>
                                       </div>
                                   </a>
                               ))}
                           </div>

                           {/* Practical Info Block */}
                           <div className="p-6 bg-emerald-900 text-white rounded-2xl space-y-3">
                               <h3 className="text-lg font-semibold flex items-center gap-2">
                                   <span>🚗</span> Як доїхати
                               </h3>
                               <p className="text-emerald-100 text-sm leading-relaxed font-light">
                                   Ми знаходимося поруч із популярними гірськолижними курортами: <strong>Буковель (~20 км)</strong> та <strong>Драгобрат (~15 км)</strong>. Зручний заїзд автомобілем або потягом до станції Ясіня.
                               </p>
                           </div>
                       </div>

                       {/* Contact Form */}
                       <div className="bg-white p-8 rounded-2xl border border-stone-200 shadow-sm">
                           { !formSubmitted && <h2 className="text-2xl font-serif font-bold text-stone-900 mb-6">Надіслати повідомлення</h2>}

                           {
                               formSubmitted ? (
                                   <div className="text-center py-8 space-y-4">
                                       <div className="w-16 h-16 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mx-auto">
                                           <CheckCircle2 size={36} />
                                       </div>
                                       <h3 className="text-2xl font-bold text-slate-900">Повідомлення прийнято!</h3>
                                       <p className="text-slate-600 text-sm">
                                           Дякуємо! Ми зв'яжемося з вами найближчим часом.
                                       </p>
                                   </div>
                               ) :
                                   (
                                       <form onSubmit={handleFormSubmit} className="space-y-4">
                                           <div>
                                               <label className="block text-sm font-medium text-stone-700 mb-1">Ваше ім'я</label>
                                               <input
                                                   type="text"
                                                   name={'name'}
                                                   placeholder="Олександр"
                                                   className="w-full px-4 py-3 rounded-xl border border-stone-300 focus:outline-none focus:ring-2 focus:ring-emerald-600 focus:border-transparent transition"
                                               />
                                           </div>

                                           <div>
                                               <label className="block text-sm font-medium text-stone-700 mb-1">Номер телефону / Telegram</label>
                                               <IMaskInput
                                                   mask="+380 (00) 000-00-00"
                                                   type="tel"
                                                   required
                                                   name="phone"
                                                   placeholder="+380 (68) 000-00-00"
                                                   value={formData.phone}
                                                   // onAccept повертає відформатоване значення при кожному вводі
                                                   onAccept={(value) => setFormData({ ...formData, phone: value })}
                                                   className="w-full px-4 py-3 rounded-xl border border-stone-300 focus:outline-none focus:ring-2 focus:ring-emerald-600 focus:border-transparent transition"
                                               />
                                           </div>

                                           <div>
                                               <label className="block text-sm font-medium text-stone-700 mb-1">Повідомлення або бажані дати</label>
                                               <textarea
                                                   rows="4"
                                                   name={'note'}
                                                   placeholder="Доброго дня! Цікавить бронювання на..."
                                                   className="w-full px-4 py-3 rounded-xl border border-stone-300 focus:outline-none focus:ring-2 focus:ring-emerald-600 focus:border-transparent transition resize-none"
                                               ></textarea>
                                           </div>

                                           <button
                                               type="submit"
                                               className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-medium py-3 rounded-xl transition duration-300"
                                           >
                                               Надіслати запит
                                           </button>
                                       </form>

                                   )
                           }
                       </div>

                   </div>
               </section>

               {/* Map Placeholder */}
               <section className="h-96 w-full bg-stone-300 relative">
                   <iframe
                       title="Google Map Location"
                       src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d42398.24346511451!2d24.4104279!3d48.2718116!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x473727b3fa6dfcdb%3A0x4000000000000000!2sYasinya%2C%20Zakarpattia%20Oblast!5e0!3m2!1suk!2sua!4v1600000000000"
                       width="100%"
                       height="100%"
                       style={{ border: 0 }}
                       allowFullScreen=""
                       loading="lazy"
                       className="filter grayscale contrast-125 opacity-90"
                   ></iframe>
               </section>

           </div>
       </>
    );
};

export default ContactsPage;